(() => {
  const hoverDevice = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
  const closeTimers = new WeakMap();
  document.addEventListener('pointerover', event => {
    if (!hoverDevice.matches || event.pointerType === 'touch') return;
    const group = event.target.closest('.gi-menu--desktop details');
    if (!group) return;
    clearTimeout(closeTimers.get(group));
    group.parentElement.querySelectorAll('details[open]').forEach(other => {
      if (other !== group) other.open = false;
    });
    group.open = true;
  });
  document.addEventListener('pointerout', event => {
    if (!hoverDevice.matches) return;
    const group = event.target.closest('.gi-menu--desktop details');
    if (!group || (event.relatedTarget && group.contains(event.relatedTarget))) return;
    closeTimers.set(group, setTimeout(() => {
      if (!group.contains(document.activeElement)) group.open = false;
    }, 160));
  });
  document.addEventListener('focusout', event => {
    const group = event.target.closest('.gi-menu--desktop details');
    if (group && !group.contains(event.relatedTarget) && !group.matches(':hover')) group.open = false;
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.gi-menu details[open]').forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = event.target.closest('.gi-menu details[open]');
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
})();
